import { React, Fragment, useState } from 'react'
import { Link } from 'react-router-dom';
import { Dialog, Disclosure, Menu, Transition, Popover } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { FunnelIcon, Squares2X2Icon } from '@heroicons/react/20/solid'

export default function Collection({ handleClick, products, categories }) {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
      setSelectedOptions((prevSelected) => {
      if (prevSelected.includes(value)) {
        return prevSelected.filter((option) => option !== value);
      } else {
        return [...prevSelected, value];
      }
    });
  };

  const filteredProducts = products.filter((item) => {
    if (selectedOptions.length === 0) {
      return true;
    } else {
      return selectedOptions.includes(item.category);
    }
  });

  return (
    <div className="bg-white pt-4">
      <>
        <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
          <div className="flex items-baseline justify-between border-b  pb-6 pt-24">
            <h1 className="text-2xl lg:text-4xl font-medium tracking-tight text-gray-900">Nouvelle Collection</h1>

            <div className="flex items-center">
              <Popover className="relative">
                  <Popover.Button className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden">
                    <FunnelIcon className="h-5 w-5" aria-hidden="true" />
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute right-0 z-10 text-start mt-2 w-56 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="">
                          <div className="px-5 py-3">
                              <h3 className="mb-1">
                                    <div className="flex w-full items-center justify-between bg-white text-sm text-gray-400 hover:text-gray-500">
                                        <span className="font-medium text-base text-gray-900">Catégories</span>
                                    </div>
                              </h3>
                              <div className="pt-3">
                                <div className="space-y-2">
                                    {categories.map((category) => (
                                <div className="flex items-center">
                                  <input
                                    id={category.id}
                                    name={category.name}
                                    defaultValue={category.slug}
                                    type="checkbox"
                                    defaultChecked={selectedOptions.includes(category.slug)}
                                    onChange={handleCheckboxChange}
                                    className="h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-300"
                                  />
                                  <label
                                    htmlFor={category.id}
                                    className="ml-3 text-sm text-gray-600"
                                  >
                                    {category.name}
                                  </label>
                                </div>
                                ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </Popover>
              <button type="button" className="-m-2 ml-5 p-2 text-gray-400 cursor-text sm:ml-7">
                <span className="sr-only">View grid</span>
                <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>

          <section aria-labelledby="products-heading" className="pb-24 pt-6">
            <h2 id="products-heading" className="sr-only">
              Products
            </h2>

            <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
              {/* Filters */}
              <form className="hidden lg:block">
                  <div className="border-b border-gray-200 pb-6">
                      <>
                        <h3 className="-my-3 flow-root">
                          <div className="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
                            <span className="font-medium text-lg text-gray-900">Catégories</span>
                          </div>
                        </h3>
                        <div className="pt-6">
                          <div className="space-y-4">
                            {categories.map((category) => (
                              <div className="flex items-center">
                                <input
                                  id={category.id}
                                  name={category.name}
                                  defaultValue={category.slug}
                                  type="checkbox"
                                  defaultChecked={selectedOptions.includes(category.slug)}
                                  onChange={handleCheckboxChange}
                                  className="h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-300"
                                />
                                <label
                                  htmlFor={category.id}
                                  className="ml-3 text-base text-gray-600"
                                >
                                  {category.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                  </div>
              </form>

              {/* Product grid */}
              <div className="lg:col-span-3">{/* Your content */}
              <div className="grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 xl:gap-x-8">
                    {filteredProducts.map((product) => (
                        <div data-aos="zoom-in">
                          <Link to={`/product/${product.id}`} className="group" >
                            <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                              <img
                                src={product.image}
                                alt={product.slug}
                                className="h-full w-full object-cover object-center group-hover:opacity-75"
                              />
                            </div>
                            <div className='flex justify-between items-end'>
                              <h3 className="mt-4 text-sm text-gray-900">{product.name}</h3>
                              <p className="mt-1 text-lg font-medium text-gray-900">{product.price}$</p>
                            </div>
                          </Link>
                          <button onClick={() => handleClick(product)} className='flex justify-center w-full text-sm font-medium text-gray-900 bg-gray-100 py-2 rounded-lg mt-3 focus:ring-1 focus:ring-black focus:ring-offset-2'>Ajouter au panier</button>
                        </div>
                    ))}
                    </div>
              </div>
            </div>
          </section>
        </main>
      </>
    </div>
  )
}
